<template>
  <div class="vendor-form">
    <p class="vendor-form-label">
      {{ label }}<span class="text-ast" v-if="isRequired">*</span>
    </p>
    <input
      class="vendor-input-date"
      type="date"
      v-model="model"
      :disabled="disabled"
      max="9999-12-31"
    />
  </div>
</template>
<script>
export default {
  props: [
    'modelName',
    'label',
    'storeName',
    'mutationName',
    'isRequired',
    'disabled',
  ],
  computed: {
    model: {
      get() {
        return this.$store.state[this.storeName][this.modelName]
      },
      set(newValue) {
        this.$store.commit(this.mutationName, {
          name: this.modelName,
          value: newValue,
        })
      },
    },
  },
}
</script>
